<template>
  
  <div>

    <b-breadcrumb :items="$options.breadcrumb"/>

    <h2>Bigfox</h2>

    <p>
      Status:

      <template v-if="device.status !== 'OFFLINE'">
        <span class="mdi mdi-network-outline text-success"> Online</span>
      </template>
      <template v-else>
        <span class="mdi mdi-network-off-outline text-danger"> Offline</span>
      </template>

    </p>

    <p>
      Serienummer: {{device.serial}}
    </p>

    <b-tabs content-class="mt-3" v-model="trackTab">
      <b-tab href="#networks">
        <template #title>
          Netwerken <b-badge variant="info">{{device.networks.totalCount}}</b-badge>
        </template>
        <p>
          <busy-btn variant="primary" @click="detectNetworks" style="width: 14em">
            <template #progressText>
              <span style="font-size: 0.8rem;">
                <span class="mdi mdi-help-network-outline"/> Detectie: <strong>100%</strong>
              </span>
            </template>
            <template #progressComplete>
              <span class="mdi mdi-check-bold"> Netwerken detecteren</span>
            </template>
            <span class="mdi mdi-help-network-outline"/> Netwerken detecteren
          </busy-btn>
          <b-btn variant="primary" v-b-modal.addNetwork class="ml-1"><span class="mdi mdi-plus-thick"/> Netwerk toevoegen</b-btn>
        </p>

        <b-table-lite :items="device.networks.nodes" :fields="$options.fields" small striped hover>
          <template v-slot:cell(actions)="row">
            <b-btn variant="danger" v-if="row.item.manual" size="sm" @click="deleteNetwork(row)"><span class="mdi mdi-trash-can-outline"/> Verwijderen</b-btn>

            <busy-btn variant="primary" size="sm" :progress="scanProgress(`scan_${row.item.id}`)" style="width: 7em" class="ml-1" @click="() => scan(row)">
              <template #progressText="{progress}">
                <span style="font-size: 0.7rem;">Scan: <strong class="text-monospace">{{progress.toFixed(0).padStart(3, '0')}}%</strong></span>
              </template>
              <template #default>
                <span class="mdi mdi-printer-search"/> Scannen
              </template>
              <template #progressComplete>
                <span class="mdi mdi-check-bold"> Scannen</span>
              </template>
            </busy-btn>

          </template>
        </b-table-lite>
      </b-tab>
      <b-tab lazy href="#printers">
        <template #title>
          Gedetecteerde printers <b-badge variant="info">{{device.printers.totalCount}}</b-badge>
        </template>
<!--        <p>
          <b-btn variant="primary" class="ml-1" @click="discovery(device)">
            <span class="mdi mdi-map-search-outline"/> Printers zoeken
          </b-btn>
        </p>-->

        <table-wrap :fields="$options.printerFields" small striped :show-empty="true" selectable
                    :query="$options.printersQuery"
                    :variables="printerVariables"
                    list-path="deviceById.printers.nodes"
                    @row-selected="onPrinterSelect"
                    ref="printersTable"
                    :state.sync="printerView">
          <template #cell(selected)="{rowSelected, index}">
            <b-form-checkbox
              :checked="rowSelected"
              @change="() => $refs.printersTable[rowSelected ? 'unselectRow' : 'selectRow'](index)">
            </b-form-checkbox>
          </template>
          <template v-slot:cell(serial)="row">
            <router-link :to="`/main/admin/printers/view/${row.item.id}`">{{row.value}}</router-link>
          </template>
          <template #cell(lastDetected)="{item:{lastDetected}}">
            <span v-if="lastDetected === null" class="text-muted">Nog niet gedetecteerd</span>
            <span v-else>{{lastDetected|format_duration($store.state.now)}}</span>
          </template>
          <template #cell(contract)="{item:{contractPrinters:{nodes}}}">
            <template v-if="nodes.length === 0">
              <i class="text-muted">Niet toegewezen</i>
            </template>
            <template v-else>
              <b-link :to="`/main/admin/contracts/view/${contract.id}`" v-for="({id, contract}, i) of nodes" :key="`${id}`"
                      :class="{'text-muted small': i !== 0}" class="mr-1"
              >{{contract.name}}</b-link>
            </template>

          </template>
          <template #cell(brand)="{item:{model}}">
            <template>{{model.brand.name}} {{model.name}}</template>
          </template>
          <template v-slot:cell(model.profileOk)="row">
            <span v-if="row.value" class="text-success"><span class="mdi mdi-check"/> OK</span>
            <span v-else class="text-danger"><span class="mdi mdi-close" /> Niet OK</span>
          </template>
          <!--<template v-slot:cell(actions)="row">
            <b-btn variant="danger" v-if="row.item.manual" size="sm"><span class="mdi mdi-trash-can-outline"/> Verwijderen</b-btn>
          </template>-->
          <template #custom-foot>
            <b-tr>
              <b-td class="p-1 pl-2 text-center"><b-icon icon="arrow-return-right"/></b-td>
              <b-td colspan="10" class="p-1">
                <!-- <b-btn size="sm" @click="showDelete = true">Verwijderen</b-btn> -->
                <busy-btn size="sm" @click="disconnect" :busy="disconnectBusy">Ontkoppelen</busy-btn>
              </b-td>
            </b-tr>
          </template>
        </table-wrap>

      </b-tab>
      <b-tab title="Logboek">

      </b-tab>
    </b-tabs>


    <b-modal id="addNetwork" ref="addNetwork" centered title="Netwerk toevoegen">
      <b-form-group
        id="fieldset-1"
        description="Invoeren in CIDR formaat (bijvoorbeeld: 192.168.123.0/24)"
        label="Netwerk"
        label-for="input-1"
        :state="newNetworkValid"
        valid-feedback="Ziet er goed uit!"
        invalid-feedback="Dat zal het niet worden"
      >
        <b-form-input id="input-1" v-model="newNetwork" trim/>
      </b-form-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-btn variant="secondary" @click="cancelNewNetwork(cancel)">Annuleren</b-btn>
        <b-btn variant="primary" @click="addNetwork(ok)">Toevoegen</b-btn>
      </template>
    </b-modal>

    <b-modal centered title="Printers verwijderen" title-class="font-weight-bold" v-model="showDelete">
      Ben je zeker?
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-btn variant="secondary" @click="cancel">Annuleren</b-btn>
        <b-btn variant="danger" @click="okDeletePrinters(ok)">Verwijderen</b-btn>
      </template>
    </b-modal>

  </div>
  
</template>

<script>

import {
    A_START_TASK,
    CIDR_V4_RE, G_BUTTON_PROGRESS,
    M_UPDATE_BIGFOX_NETWORK_VIEW,
    M_UPDATE_BIGFOX_PRINTER_VIEW
} from '../../lib/constants';
import actionField from '../../lib/actionField';
import discovery from '../../lib/discovery';
import TableWrap from '@/components/TableWrap';
import vuex_computed from '@/lib/vuex_computed';
import trackTab from '@/lib/trackTab';
import BusyBtn from '@/components/BusyBtn';

export default
{
    apollo:
    {
        $subscribe:
        {
            device:
            {
                query: require('../../graphql/viewDevice.sub.gql'),
                result({data: { deviceById }})
                {
                    this.device = deviceById;
                },
                variables()
                {
                    return { id: this.id }
                }
            }
        }
    },
    computed:
    {
        newNetworkValid()
        {
            return CIDR_V4_RE.test(this.newNetwork);
        },
        networkView: vuex_computed('bigfoxNetworkView', M_UPDATE_BIGFOX_NETWORK_VIEW),
        printerView: vuex_computed('bigfoxPrinterView', M_UPDATE_BIGFOX_PRINTER_VIEW),
        trackTab: trackTab('t'),
        scanProgress()
        {
            return this.$store.getters[G_BUTTON_PROGRESS];
        }
    },
    components: {BusyBtn, TableWrap },
    data()
    {
        return {
            device: { networks: { nodes: [] }, printers: { } },
            disconnectBusy: false,
            newNetwork: '',
            printerVariables: { id: this.id },
            selectedPrinters: [],
            showDelete: false
        }
    },
    methods:
    {
        async addNetwork(ok)
        {
            await this.$apollo.mutate(
                {
                    mutation: require('../../graphql/addNetwork.mutation.gql'),
                    variables:
                    {
                        input:
                        {
                            network:
                            {
                                manual: true,
                                network: this.newNetwork,
                                device: { connectById: {id: this.id } }
                            }
                        }
                    }
                }
            );
            ok();
            this.newNetwork = '';
        },
        async deleteNetwork(row)
        {
            const yes = await this.$bvModal.msgBoxConfirm(
                `Ben je zeker dat je het netwerk ${row.item.network} wil verwijderen?`,
                {
                    title: 'Netwerk verwijderen',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Verwijderen',
                    cancelTitle: 'Annuleren',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            );

            if(yes)
            {
                await this.$apollo.mutate(
                    {
                        mutation: require('../../graphql/mutation/delete_network.gql'),
                        variables: { id: row.item.id }
                    }
                );
            }
        },
        async detectNetworks()
        {
            await this.$apollo.mutate(
                {
                    mutation: require('../../graphql/mutation/explore_networks.gql'),
                    variables: { id: this.id }
                }
            );
        },
        async okDeletePrinters(ok)
        {
            const ids = this.selectedPrinters.map(p => p.id);

            await this.$apollo.mutate(
                {
                    mutation: require('../../graphql/mutation/delete_printers.gql'),
                    variables: { ids }
                }
            );

            ok();
        },
        showAddNetwork()
        {
            this.$refs.addNetwork.show();
        },
        cancelNewNetwork(cancel)
        {
            cancel();
            this.newNetwork = '';
        },
        async disconnect()
        {
            try
            {
                this.disconnectBusy = true;
                let printer;
                for(printer of this.selectedPrinters)
                {
                    await this.$apollo.mutate(
                        {
                            mutation: require('../../graphql/mutation/disconnectPrinter.gql'),
                            variables: { id: printer.id }
                        }
                    );
                }
            }
            catch (e)
            {
                console.error(e);
            }
            finally
            {
                this.disconnectBusy = false;
                this.$refs.printersTable.clearSelected();
            }
        },
        async scan(row)
        {
            const { data: { scanNetwork } } = await this.$apollo.mutate(
                {
                    mutation: require('../../graphql/mutation/scanNetwork.gql'),
                    variables: { id: row.item.id }
                }
            );

            await this.$store.dispatch(
                A_START_TASK,
                {
                    apollo: this.$apollo,
                    buttonId: `scan_${row.item.id}`,
                    taskIds: scanNetwork.tasks.map(t => t.taskId)
                }
            );
        },
        discovery,
        onPrinterSelect(selection)
        {
            this.selectedPrinters = selection;
        }
    },
    props: [ 'id' ],
    breadcrumb:
    [
        { text: 'Administratie' },
        { text: 'Bigfox', to: '/main/admin/bigfox' },
        { text: 'Bigfox' }
    ],
    fields:
    [
        {
            key: 'network',
        },
        actionField
    ],
    printerFields:
    [
        {
            key: 'selected',
            label: '',
            tdClass: 'p-1 w-0',
            selectAll: true,
            thClass: 'p-0 w-0'
        },
        {
            key: 'brand',
            label: 'Merk & model'
        },
        {
            key: 'serial',
            label: 'Serienummer',
            search: 'STRING',
            sortable: true,
            sort: 'SERIAL'
        },
        {
            key: 'contract',
            label: 'Contract'
        },
        {
            key: 'snmpHost',
            label: 'SNMP host',
            sortable: true,
            sort: 'SNMP_HOST'
        },
        {
            key: 'snmpLocation',
            label: 'SNMP locatie',
            sortable: true,
            sort: 'SNMP_LOCATION'
        },
        {
            key: 'lastDetected',
            label: 'Laatst gedetecteerd',
            tdClass: 'text-nowrap',
            sortable: true,
            sort: 'LAST_DETECTED'
        },
        {
            key: 'model.profileOk',
            label: 'Profiel status',
            sortable: true,
            sort: 'MODEL_BY_MODEL_ID__PROFILE_OK'
        },
        {
            key: 'model.profile.name',
            label: 'Profiel',
            sortable: true,
            sort: 'MODEL_BY_MODEL_ID__NAME'
        }
    ],
    printersQuery: require('../../graphql/live/device_printer_list.gql')
}
</script>

<style>
</style>